import { TickFormatter } from '@nivo/axes';
import React from 'react';

import { CmCard, CmHeading } from '@/components/uiParts';
import { createBarDatumFromChartDatum } from '@/domain/models/Chart';
import { SalesByTimePeriodItem } from '@/domain/models/SalesReport';

import { BarChart, ChartContainer } from './Charts';

interface Props {
  salesHour: SalesByTimePeriodItem[];
}

const projectToTotalPriceDatumByHour = (salesHour: SalesByTimePeriodItem[]) => {
  // Create a map from the provided salesHour data
  const salesMap = new Map<number, number>();
  salesHour.forEach(({ time_period, total_sales }) => {
    const hour = parseInt(time_period.split(':')[0], 10);
    salesMap.set(hour, total_sales);
  });

  // Map each hour to its total sales or default to 0 if not present
  const totalPriceDatum: {
    id: 'totalPrice';
    data: { x: string; y: number }[];
  } = {
    id: 'totalPrice',
    data: Array.from({ length: 24 }, (_, hour) => {
      const x = hour.toString();
      const y = salesMap.get(hour) || 0;
      return { x, y };
    }),
  };

  return totalPriceDatum;
};

export const SalesByHourOfTheDay: React.FC<Props> = ({ salesHour }) => {
  const totalPriceData = projectToTotalPriceDatumByHour(salesHour);
  const barData = totalPriceData
    ? createBarDatumFromChartDatum(totalPriceData)
    : [];

  const axisFormatter: TickFormatter = (d) => {
    return Number(d) % 3 === 0 ? d.toString() : '';
  };

  return (
    <CmCard>
      <CmHeading as="h2">時間帯ごと売上</CmHeading>
      <ChartContainer mt={5} height="250px" width="100%">
        <BarChart data={barData} axisBottomFormatter={axisFormatter} />
      </ChartContainer>
    </CmCard>
  );
};
